import {Component, Inject} from '@angular/core';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';

@Component({
    selector: 'app-closing-pop-up',
    templateUrl: './closing-pop-up.component.html',
})
export class ClosingPopUpComponent {

    constructor(public dialogRef: MatDialogRef<ClosingPopUpComponent>,
                @Inject(MAT_DIALOG_DATA) data) {
    }
}
